export default defineNuxtRouteMiddleware((to, _from) => {
  const user = useSupabaseUser();
  const path = '/my-account';
  if (user.value) {
    console.log('`redirect-if-logged-in` Middleware found user... redirecting to ' + path);
    return navigateTo({
      path: path,
      query: to.query
    });
  }
});
